export default __webpack_public_path__ + "static/media/chartDiagram.8b31b68b.svg";